import { Box } from '@mui/material'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Outlet } from 'react-router-dom'

function HeaderLayout() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Header />
            <Outlet /> {/* This renders the nested route */}
            <Footer />
        </Box>
    )
}

export default HeaderLayout
